import { InputBase } from "@mui/material";
import { styled } from "@mui/system";
import React from "react";

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#F9F9FA99",
  border: "1px solid #ced4da",
  fontSize: 16,
  padding: "5px 4px 5px 4px",
  borderRadius: theme.shape.borderRadius,
  "&.Mui-focused": {
    borderColor: "#4A1D9C",
    borderWidth: "2px",
  },
}));

// probably not all things work like in the TextField component yet
// disableInjectingGlobalStyles prevents InputBase from injecting global CSS styles
// for every instance, which improves performance when rendering many fields.
const OptimizedTextField = React.forwardRef<HTMLInputElement, any>(
  (props, ref) => (
    <StyledInputBase
      size="small"
      {...props}
      inputRef={ref}
      disableInjectingGlobalStyles
    />
  ),
);
OptimizedTextField.displayName = "OptimizedTextField";

// import React from "react";
// import TextField from "@mui/material/TextField";

// const OptimizedTextField = React.forwardRef((props, ref) => (
//   <StyledInputBase size="small" {...props} inputRef={ref} />
// ));

// //export default OptimizedTextField;

export default OptimizedTextField;
